module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5FQZM"))).then(() => parcelRequire('8rm4T'));